import React from "react";
import DatePicker from "react-datepicker";
import Required from "./Required";
import { Label } from "reactstrap";
import moment from "moment/moment";
import { get } from "react-hook-form";

const MyDate = ({
  required,
  time,
  format,
  title,
  name,
  placeholder,
  max,
  min,
  errors,
  watch,
  register,
  trigger,
  setValue,
  disabled,
}) => {
  const error = get(errors, name);
  return (
    <div className="form-group my-2">
      <Label htmlFor={name} className="form-label">
        {title}
        {title && required && <Required />}
      </Label>
      <div className="form-control-wrap">
        <DatePicker
          id={name}
          // className="form-control date-picker"
          className={`form-control ${error ? "is-invalid" : ""}`}
          placeholderText={placeholder}
          {...register(name, {
            required: required ?  `Please choose ${title}`:false,
          })}
          onChange={(date) => {
            const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
            setValue(name, date); // Save the formatted date
            trigger(name);
          }}
          selected={watch(name)}
          dateFormat={format || "dd/MM/yyyy"}
          maxDate={max}
          minDate={min}
          showYearDropdown
          scrollableYearDropdown
          dropdownMode="select"
          // withPortal
          // disabled={mode === "Edit" ? true : null}
          showMonthDropdown
          // yearDropdownItemNumber={12}
          timeInputLabel="Time:"
          showTimeInput={time}
          disabled={disabled}
        />
      </div>
      {error && <p className="invalid">{error?.message}</p>}
    </div>
  );
};

export default MyDate;
